module.exports = __webpack_public_path__ + "img/icon-left-arrow.961e9abe.png";